import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

const translations = {
  en: require("../locales/en.json"),
  de: require("../locales/de.json"),
  ro: require("../locales/ro.json"),
};

const useTranslation = () => {
  const { language } = useContext(LanguageContext);

  const t = (key) => {
    return translations[language][key] || key;
  };

  return { t };
};

export default useTranslation;
